

class DataHelper {
    static getStaticContextData(props, regexPattern) {
        if(props && props["staticContext"] && props["staticContext"].appData) {
            var appData = props["staticContext"].appData;

            for(var key in appData) {
                if(key.match(regexPattern)) {
                    return appData[key];
                }
            }
        }
    };

    static getAppData(props) {
        if(props && props.appData) {
            return props.appData;
        }
    };

    static getDataFromDataContext(regexPattern) {
        var appData = __app.dataContext;
        for(var key in appData) {
            if(key.match(regexPattern)) {
                return appData[key];
            }
        }
    };
}

module.exports = DataHelper;